(function ($) {
    $(document).ready(function () {
        pressAwardsCarousel();
    });

    function pressAwardsCarousel() {
        var wraps = $('.section.press_awards.layout_carousel');
        wraps.each(function () {
            var wrap = $(this).find('.slider_inner_wrap');
            var countEl = wrap.find('.article_wrap').length;
            // A single slide does not need slick at all: the item is laid out by
            // the .single_item CSS instead.
            if (wrap.length > 0 && countEl > 1) {
                var slidesToShow = 3;
                wrap.on("init", function () {
                    lazyLoadInstance.update();
                });
                wrap.slick({
                    autoplay: false,
                    arrows: true,
                    dots: countEl > slidesToShow,
                    infinite: true,
                    appendDots: wrap.closest('.section').find('.pager'),
                    prevArrow: accor_arrow_prev,
                    nextArrow: accor_arrow_next,
                    slidesToShow: 3,
                    slidesToScroll: 3,
                    variableWidth: false,
                    centerMode: false,
                    rtl: $('html').attr('dir') == 'rtl',
                    responsive: [
                        {
                            breakpoint: 991,
                            settings: {
                                slidesToShow: 2,
                                slidesToScroll: 2,
                            }
                        },
                        {
                            breakpoint: 600,
                            settings: {
                                slidesToShow: 1,
                                slidesToScroll: 1,
                                adaptiveHeight: true
                            }
                        },
                    ]
                });
            }
        });
    }
})(jQuery);